<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                model-def="whatsapplists"
                model-class="whatsapplist"
                :infos="infos"
                top-class=""
                :activities="true">

                <template slot="relations">
                    <belongstomany-show
                        class="pb-4"
                        :headers="headers"
                        title="Aziende"
                        paginate
                        :url="'company-whatsapplists-filters'"
                        :subFilters="{'list_id': id}">
                        <template slot="table-footer">
                            <v-row class="pa-0 ma-0"  justify="center">
                                <v-col lg="2" md="4" sm="6" class="pt-0">
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mdi-whatsapp</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Totale Aziende</v-list-item-title>
                                                <v-list-item-subtitle>{{ countCompanies }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-col lg="2" md="2" sm="6" class="pt-0">
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mdi-whatsapp</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Totale Numeri WhatsApp</v-list-item-title>
                                                <v-list-item-subtitle>{{ countCompaniesWhatsApp }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </template>
                    </belongstomany-show>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {

        name: 'whatsapplist',
        components: {
            BelongstomanyShow
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                relations: {},
                modelDef: 'whatsapplists',
                headers: [
                    {
                        'text': '#',
                        'sortable': false,
                        'value': 'number',
                        'width': '40'
                    },
                    {
                        'text': 'Azioni',
                        'sortable': false,
                        'value': 'actions',
                        'width': '80',
                        'actions': [
                            {
                                'action': 'route',
                                'icon': 'mdi-eye',
                                'color': 'primary',
                                'text': 'Visualizza Azienda',
                                'route': 'companies-show',
                                'route_param_key': 'company_id'
                            }
                        ]
                    },
                    {
                        'text': 'Numero WhatsApp',
                        'sortable': false,
                        'value': 'whatsapp_telephone',
                    },
                    {
                        'text': 'Numero Primario',
                        'sortable': false,
                        'value': 'primary_telephone',
                    },
                    {
                        'text': 'Numero Secondario',
                        'sortable': false,
                        'value': 'secondary_telephone',
                    },
                    {
                        'text': 'Azienda',
                        'sortable': false,
                        'value': 'company',
                    },
                    {
                        'text': 'Accettazione WhatsApp',
                        'sortable': false,
                        'value': 'whatsapp_opted_in',
                        'type': 'boolean',
                    },
                    {
                        'text': 'Data Accettazione',
                        'sortable': false,
                        'value': 'whatsapp_opted_in_date',
                        'type': 'date',
                    },
                    {
                        'text': 'Data Aggiunta Lista',
                        'sortable': false,
                        'value': 'created_at',
                        'type': 'date',
                    }
                ]
            }
        },


        computed: {

            countCompanies() {
                if(this.models.whatsapplist && this.models.whatsapplist.companies_count) {
                    return this.models.whatsapplist.companies_count
                } else return 0
            },

            countCompaniesWhatsApp() {
                if(this.models.whatsapplist && this.models.whatsapplist.companies_count_whatsapp) {
                    return this.models.whatsapplist.companies_count_whatsapp
                } else return 0
            },
        },

        created() {
            this.axios.get(this.modelDef + '/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos
                this.$store.commit('endProgress')
                this.load = true

            }, response => {
                // error callback
            })
        }
    }
</script>
